import React, { useContext, useEffect, useState, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useQueryErrorResetBoundary } from 'react-query';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import CircularLoader from 'app/design/uiComponents/CircularLoader';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
  useTheme,
  Button,
  Menu,
  Tabs,
  Tab,
  ButtonGroup,
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import ContentTabs from 'app/design/itemsComponent/ContentTabs';
import CommonOnboarding from 'app/design/speedBot/ComponentItem/Portfolio/CommonOnboarding';
import PageHeader from 'app/design/speedBot/PageHeader';
import ActivePaperTabs from 'app/components/Portfolio/ActivePaperTabs';
import { useCheckPortfolioDataExist } from 'services/Portfolio/useGetPortfolioActivePaper';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallBack from 'app/components/Common/ErrorFallBack';
import { useBreadcrumbManager } from 'app/components/Common/Breadcrumb';
import { getQueryParam, groupBy } from 'utils/GenericFunctions';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import useGetProfile from 'services/Menu/useGetProfile';
import {
  useGetMediaQueryDown,
  useGetMediaQueryUp,
} from 'app/hooks/useGetMediaQuery';
import { useIsFeatureFlag } from 'app/components/Common/FeatureFlag';
import { FEATURES } from 'types/Feature';
// import useReportUserAcitivity from 'services/UserActivity/useReportUserActivity';
// import { UserActivityTypes } from 'services/UserActivity/types';
// import HaveReferralDialog from 'app/components/Portfolio/HaveReferralDialog';
import { ToggleContext } from 'app/components/Context/ToggleViewContext';
import { PositionsListLayoutProps } from 'types/ComponentTypes';
import AllTodaysPositionLayout from 'app/design/layouts/AllTodaysPosition';
import useGetBotAllTodayPosition from 'services/Portfolio/useGetAllTodayPosition';
import BotHistoryPositionsModal from 'app/components/Bots/BotHistory/BotHistoryPositionsModal';
import FormattedMessage from 'app/design/uiComponents/FormattedMessage';
import { Position } from 'types/ApiServicesTypes';
import MuiSwitchUnstyled from 'app/design/uiComponents/MuiUnstyledSwitch';
import { useGetTickData } from 'app/hooks/useGetTickData';
import useSetReferral from 'services/Menu/useSetReferral';
import { PRODUCT_TOUR } from 'constants/common';
import ProductTour from 'app/components/Common/ProductTour/ProductTour';
import { BotPageProductSteps } from 'app/components/Common/ProductTour/ProductTourData';
import BrokerwisePositionsCards from 'app/components/Portfolio/BrokerwisePositionsCards';
import { calculateLiveFeedPostitionSum } from 'app/components/Portfolio/utils';
import { useGetPortfolio } from 'services/Portfolio/useGetPortfolioActivePaper';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import useGetSiteInfo from 'services/common/useGetSiteInfo';
import useGetBrokers from 'services/Menu/useGetBrokers';
import { filterArrayWithKey } from 'utils/GenericFunctions';
import PortfolioSymbolItem from 'app/design/speedBot/ComponentItem/Portfolio/PortfolioSymbolItem';
import HintAlert from 'app/design/speedBot/ComponentItem/Bots/HintAlert';
import { WarningAmberOutlined } from '@mui/icons-material';
import { deepOrange } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import { useCalcuatePortfolioSummaryUIData } from 'app/design/speedBot/ComponentItem/Portfolio/PortfolioSummary';

// import { Position } from 'vscode';

// import { Position } from 'vscode';

export function PortfolioPage() {
  const { t } = useTranslation();
  const history = useHistory();
  const isMdUp = useGetMediaQueryUp('md');
  const isMdDown = useGetMediaQueryDown('lg');
  const { ptypeOld } = useParams<{ ptypeOld?: string }>();
  const startsWith = window.location.pathname.startsWith('/bot');
  const ptype = ptypeOld
    ? ptypeOld
    : getQueryParam('ptype', startsWith ? 'mybots' : 'active');
  const [selectedPosition, setSelectedPosition] = useState<Position | null>(
    null,
  );
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [viewMode, setViewMode] = useState<'bots' | 'positions' | 'brokerwise'>(
    'bots',
  );
  // Dropdown state for custom viewMode dropdown
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  // Remove handleMenuSelect and related dropdown code if present

  const breadcrumb = useBreadcrumbManager();
  const { reset } = useQueryErrorResetBoundary();
  const [selectedTab, setSelectedTab] = useState<number>(
    // ptype.toLowerCase() === 'active' || ptype.toLowerCase() === 'live'
    //   ? 0
    //   : ptype.toLowerCase() === 'paper'
    //   ? 1
    //   : 2,
    ptype.toLowerCase() == 'manual'
      ? 3
      : ptype.toLowerCase() === 'mybots'
      ? 2
      : ptype.toLowerCase() === 'paper'
      ? 1
      : 0,
  );

  const objQuery = useCheckPortfolioDataExist();
  const { data: profileDetails } = useGetProfile();
  const isManualTrading = useIsFeatureFlag([FEATURES.IS_MANUAL_TRADING]);
  const isViewAllPositions = useIsFeatureFlag([FEATURES.IS_VIEW_ALL_POSITIONS]);
  const isBrokerwisePositionsView = useIsFeatureFlag([
    FEATURES.IS_BROKERWISE_POSITIONS_VIEW,
  ]);

  // const isMybotsInPortfolio = useIsFeatureFlag([
  //   FEATURES.IS_MYBOTS_IN_PORTFOLIO,
  // ]);
  // const isReferralOauthUser = useIsFeatureFlag([
  //   FEATURES.IS_REFERRAL_OAUTH_USER,
  // ]);

  const { open, toggle } = useContext(ToggleContext);
  // const [open, setOpen] = useState(false);
  // const toggle = () => {
  //   setOpen(!open);

  // };
  // 2. Sync dropdown with open logic
  const handleViewModeChange = (
    event: React.SyntheticEvent,
    value: 'bots' | 'positions' | 'brokerwise',
  ) => {
    setViewMode(value);
    if (value === 'bots' && open) toggle?.(); // set open to false if not already
    if (value === 'positions' && !open) toggle?.(); // set open to true if not already
    // No toggle for brokerwise
  };

  const handleChange = (newValue: number) => {
    // if (isPaperTrading) {
    setSelectedTab(newValue);
    if (open) {
      toggle && toggle();
    }
    // }
  };

  useEffect(() => {
    breadcrumb.resetBreadcrumpPaths();
  }, [breadcrumb]);

  const { data, isLoading } = useGetBotAllTodayPosition(Boolean(open), ptype);
  // const symbols = (data && data.map(symbol => symbol.trading_symbol)) || [];
  const botPositions = data && data.length > 0 ? data : [];
  const theme = useTheme();
  const botGrpPositions = groupBy(
    botPositions,
    'exit_time',
    true,
  ) as PositionsListLayoutProps;
  //change ptype from url
  useEffect(() => {
    history.replace({
      search: `ptype=${
        selectedTab === 0
          ? 'active'
          : selectedTab === 1
          ? 'paper'
          : selectedTab === 2
          ? 'mybots'
          : 'manual'
      }`,
    });
    void objQuery.refatch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, selectedTab]);
  const handleModalOpen = (positionData: Position) => {
    setSelectedPosition(positionData);
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
    setSelectedPosition(null);
  };
  const { data: siteInfo } = useGetSiteInfo();
  const { data: portfolioData } = useGetPortfolio();
  const querydata = portfolioData ? ptype === 'ACTIVE' ? portfolioData?.active  : portfolioData?.paper : { data : {
    todays_change: 0,
    total_profit_loss: 0,
    total_profit_loss_per:0,
    initial_capital: 0,
    portfolio_value: 0,
    bots: {},
  }, bots : [], symbols : [], positionData : []};
  const uidata = useCalcuatePortfolioSummaryUIData(querydata, siteInfo);
  const liveFeedData = uidata ? uidata?.liveFeedData : {}; 

  let liveFeedTodaysPosData: { [id: number]: number } = {};
  if (botPositions && botPositions.length > 0) {
    botPositions.forEach(posData => {
      const sum = calculateLiveFeedPostitionSum(liveFeedData, posData);
      liveFeedTodaysPosData = {
        ...liveFeedTodaysPosData,
        [posData.id]: sum,
      };
    });
  }

  // Add a ref to ensure the auto-switch only happens once
  const didAutoSwitch = useRef(false);

  useEffect(() => {
    if (!didAutoSwitch.current && portfolioData) {
      // If on "active" tab and no active bots, switch to paper or mybots
      if (
        selectedTab === 0 &&
        (!portfolioData.active ||
          !portfolioData.active.bots ||
          portfolioData.active.bots.length === 0)
      ) {
        if (
          portfolioData.paper &&
          portfolioData.paper.bots &&
          portfolioData.paper.bots.length > 0
        ) {
          setSelectedTab(1);
          didAutoSwitch.current = true;
        } else {
          setSelectedTab(2);
          didAutoSwitch.current = true;
        }
      } else if (
        selectedTab === 1 &&
        (!portfolioData.paper ||
          !portfolioData.paper.bots ||
          portfolioData.paper.bots.length === 0)
      ) {
        setSelectedTab(2);
        didAutoSwitch.current = true;
      } else {
        didAutoSwitch.current = true;
      }
    }
  }, [portfolioData, selectedTab]);

  const tabs = [
    {
      label: t('bot_status.live'),
      ...(objQuery.isActiveWarning && {
        iconProps: {
          icon: <WarningAmberIcon />,
          color: 'warning.main',
        },
      }),
    },
    {
      label: isMdUp ? t('bot_status.paper') : 'Forward',
      ...(objQuery.isPaperWarning && {
        iconProps: {
          icon: <WarningAmberIcon />,
          color: 'warning.main',
        },
      }),
    },
    {
      label: 'All Bots',
    },
    {
      label: `Manual ${isMdUp ? 'Trading' : ''}`,
      ...(objQuery.isPaperWarning && {
        iconProps: {
          icon: <WarningAmberIcon />,
          color: 'warning.main',
        },
      }),
    },
  ];
  const referralSetMutation = useSetReferral();
  const referralCode = localStorage.getItem('referral');
  useEffect(() => {
    if (
      referralCode &&
      profileDetails &&
      !profileDetails.referred_by &&
      profileDetails.is_oauth_user
    ) {
      referralSetMutation.mutate(
        { referralCode: referralCode },
        {
          onSuccess: res =>
            res.success === true
              ? localStorage.removeItem('referral')
              : localStorage.removeItem('referral'),
        },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: brokersData } = useGetBrokers();
  const isShowTicksDataWithoutBroker = useIsFeatureFlag([
    FEATURES.IS_SHOW_TICKS_DATA_WITHOUT_BROKER,
  ]);
  const isLgUp = useGetMediaQueryUp('lg');
  const portfolioSymbols =
    siteInfo?.portfolio_symbols?.slice(0, isLgUp ? 3 : 2) || [];
  const filteredBrokersData =
    brokersData && filterArrayWithKey(brokersData, 'isVerified', true);
  const showTickMessage = isShowTicksDataWithoutBroker
    ? true
    : filteredBrokersData && filteredBrokersData.length > 0
    ? true
    : false;

  // const ToggleContext = createContext<boolean>({toggle:false,})

  return (
    <>
      <Helmet>
        <title>Portfolio</title>
        <meta name="description" content="Portfolio Page" />
      </Helmet>
      <CircularLoader open={objQuery.isLoading} />
      {!objQuery.isLoading ? (
        // !objQuery.isDataExist ? (
        //   <CommonOnboarding type={ptype} />
        // ) :
        <React.Fragment>
          <Box
            className="sticky-top"
            sx={{ backgroundColor: theme.palette.common.white }}
          >
            <PageHeader
              variant="portfolio"
              title={`${
                isMdUp
                  ? `${
                      profileDetails && profileDetails.name
                        ? profileDetails.name + "'s "
                        : ''
                    }`
                  : ''
              }${!open ? t('portfolio.page_title.portfolio') : 'Positions'}`}
              tabs={
                !objQuery.isLoading ? (
                  <Box
                    display={'flex'}
                    flexDirection={isMdDown ? 'column' : 'row'}
                    alignItems={isMdDown ? 'center' : 'flex-start'}
                  >
                    <ContentTabs
                      value={selectedTab}
                      onChange={(e, newVal) => handleChange(newVal)}
                      tabs={
                        !isManualTrading
                          ? tabs.filter(tab => !tab.label.includes('Manual'))
                          : tabs
                      }
                    />
                    {isMdUp && isViewAllPositions && ptype === 'paper' ? (
                      <Box
                        // flex={1}
                        display="flex"
                        alignItems="center"
                        gap={2}
                        p={1}
                      >
                        <ButtonGroup
                          variant="outlined"
                          color="primary"
                          size="small"
                          sx={{
                            minWidth: 100,
                            borderRadius: '12px',
                            boxShadow: 1,
                          }}
                        >
                          <Tooltip title="See all bots">
                            <Button
                              variant={!open ? 'contained' : 'outlined'}
                              color="primary"
                              onClick={() => {
                                if (open) toggle?.();
                              }}
                              aria-pressed={!open}
                              sx={{
                                borderRadius: '12px 0 0 12px',
                                textTransform: 'none',
                                px: 1,
                                py: 0.5,
                              }}
                            >
                              Bots
                            </Button>
                          </Tooltip>
                          <Tooltip title="See all Positions">
                            <Button
                              variant={open ? 'contained' : 'outlined'}
                              color="primary"
                              onClick={() => {
                                if (!open) toggle?.();
                              }}
                              aria-pressed={open}
                              sx={{
                                borderRadius: '0 12px 12px 0',
                                textTransform: 'none',
                                px: 1,
                                py: 0.5,
                              }}
                            >
                              Positions
                            </Button>
                          </Tooltip>
                        </ButtonGroup>
                      </Box>
                    ) : (
                      isMdUp &&
                      isViewAllPositions &&
                      ptype === 'active' && (
                        <Box display="flex" alignItems="center" gap={2} p={1}>
                          {/* MUI Tabs for viewMode selection */}
                          {/* <Tabs
                            value={viewMode}
                            onChange={handleViewModeChange}
                            indicatorColor="primary"
                            textColor="primary"
                            sx={{ minWidth: 180 }}
                          >
                            <Tab label="Bots" value="bots" />
                            <Tab label="Positions" value="positions" />
                            <Tab
                              label="Brokerwise Positions"
                              value="brokerwise"
                            />
                          </Tabs> */}

                          <ButtonGroup
                            variant="outlined"
                            color="primary"
                            size="small"
                            sx={{
                              minWidth: 100,
                              borderRadius: '12px',
                              boxShadow: 1,
                            }}
                          >
                            <Button
                              variant={
                                viewMode === 'bots' ? 'contained' : 'outlined'
                              }
                              color="primary"
                              onClick={e => handleViewModeChange(e, 'bots')}
                              aria-pressed={viewMode === 'bots'}
                              sx={{
                                borderRadius: '12px 0 0 12px',
                                textTransform: 'none',
                                px: 1,
                                py: 0.5,
                              }}
                            >
                              Bots
                            </Button>
                            <Button
                              variant={
                                viewMode === 'positions'
                                  ? 'contained'
                                  : 'outlined'
                              }
                              color="primary"
                              onClick={e =>
                                handleViewModeChange(e, 'positions')
                              }
                              aria-pressed={viewMode === 'positions'}
                              sx={{
                                borderRadius: isBrokerwisePositionsView
                                  ? 0
                                  : '0 12px 12px 0',

                                textTransform: 'none',
                                px: 1,
                                py: 0.5,
                              }}
                            >
                              Positions
                            </Button>
                            {isBrokerwisePositionsView && (
                              <Button
                                variant={
                                  viewMode === 'brokerwise'
                                    ? 'contained'
                                    : 'outlined'
                                }
                                color="primary"
                                onClick={e =>
                                  handleViewModeChange(e, 'brokerwise')
                                }
                                aria-pressed={viewMode === 'brokerwise'}
                                sx={{
                                  borderRadius: '0 12px 12px 0',
                                  textTransform: 'none',
                                  px: 1,
                                  py: 0.5,
                                }}
                              >
                                Brokers
                              </Button>
                            )}
                          </ButtonGroup>
                          {/* ...other controls/buttons if needed... */}
                        </Box>
                      )
                    )}
                  </Box>
                ) : (
                  <></>
                )
              }
            />
            {/* Portfolio symbols and warning block */}
            {portfolioSymbols.length > 0 && (
              <Box className="p-main-spacing" sx={{ py: 2 }}>
                <Box
                  display={'flex'}
                  alignItems="center"
                  sx={{
                    pb: { xs: 1, md: 0 },
                    justifyContent: { xs: 'space-between', md: 'flex-end' },
                  }}
                >
                  {!showTickMessage && (
                    <Box marginRight={'auto'}>
                      <HintAlert
                        severity="warning"
                        textColor={deepOrange['900']}
                        iconColor={deepOrange['900']}
                        hintTextKey="home.hint_text"
                        icon={
                          <WarningAmberOutlined
                            sx={{ color: deepOrange['A400'] }}
                          />
                        }
                      />
                    </Box>
                  )}
                  {portfolioSymbols.map((symbol, i) => (
                    <PortfolioSymbolItem
                      key={symbol.value}
                      liveFeedData={liveFeedData}
                      symbol={symbol}
                      isLast={i === portfolioSymbols.length - 1}
                    />
                  ))}
                </Box>
              </Box>
            )}
          </Box>
          <ErrorBoundary
            key={location.pathname}
            FallbackComponent={ErrorFallBack}
            onReset={reset}
          >
            {/* 5. Render based on viewMode */}
            {!objQuery.isDataExist &&
            (ptype === 'active' || ptype === 'paper') ? (
              <CommonOnboarding type={ptype} />
            ) : viewMode === 'brokerwise' &&
              ptype === 'active' &&
              isBrokerwisePositionsView ? (
              <BrokerwisePositionsCards
                portfolioData={portfolioData}
                liveFeedTodaysPosData={liveFeedTodaysPosData}
              />
            ) : !open ? (
              <ActivePaperTabs
                selectedTab={selectedTab}
                handleChangeTab={handleChange}
                ptype={ptype == 'live' ? 'active' : ptype}
              />
            ) : (
              <AllTodaysPositionLayout
                liveFeedData={liveFeedData}
                notMdUpData={botPositions}
                data={botGrpPositions}
                handleClick={handleModalOpen}
                handleChangeTab={handleChange}
                isloading={isLoading}
              />
            )}
          </ErrorBoundary>
        </React.Fragment>
      ) : (
        <></>
      )}
      {/* {isReferralOauthUser &&
        profileDetails?.is_oauth_user &&
        !profileDetails?.referred_by && (
          <HaveReferralDialog referralCode={profileDetails?.referral_code} />
        )} */}
      {selectedPosition && (
        <BotHistoryPositionsModal
          open={openModal}
          handleClose={handleModalClose}
          data={selectedPosition}
          title={<FormattedMessage id="buttons.position" />}
        />
      )}
      {!JSON.parse(localStorage.getItem(PRODUCT_TOUR) as string)[
        'Bot Page'
      ] && (
        <ProductTour
          steps={BotPageProductSteps(objQuery.isDataExist)}
          tour_page="Bot Page"
        />
      )}
    </>
  );
}
